var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container-inputrich" }, [
    _vm.isRender
      ? _c("div", {
          ref: "text-input",
          class: [
            "text-input",
            {
              "is-invalid": _vm.isValid === false || _vm.forceIsValid === false
            },
            { disabled: _vm.disabled }
          ],
          attrs: { contenteditable: _vm.contenteditable },
          domProps: { innerHTML: _vm._s(_vm.html) },
          on: { keydown: _vm.onKeydown, click: _vm.onClick }
        })
      : _vm._e(),
    _vm._v(" "),
    _vm.helper
      ? _c("div", { staticClass: "helper" }, [
          _vm._v("\n    " + _vm._s(_vm.helper) + "\n  ")
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.variable.show
      ? _c(
          "div",
          {
            directives: [
              {
                name: "click-outside",
                rawName: "v-click-outside",
                value: _vm.hideVariableDowndown,
                expression: "hideVariableDowndown"
              }
            ],
            staticClass: "variables"
          },
          [
            _c(
              "ul",
              _vm._l(_vm.variables, function(item, index) {
                return _c(
                  "li",
                  {
                    key: index,
                    class: [{ hover: _vm.variable.hoverIndex === index }],
                    on: {
                      click: function($event) {
                        return _vm.onSelectVariable(item)
                      },
                      mouseover: function($event) {
                        return _vm.onMouseOver(index)
                      },
                      mouseleave: _vm.onMouseLeave
                    }
                  },
                  [_vm._v("\n        " + _vm._s(item.name) + "\n      ")]
                )
              }),
              0
            )
          ]
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-9157b072", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9157b072","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/BaseInputVariable.vue
// module id = null
// module chunks = 